import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealConstructionItem } from '~/models/DealConstructionItem';

const paths = {
  index: 'vendors/deals/:deal_id/deal_construction_items'
};

type TIndex = (id: number | null) => SwrReturnType<DealConstructionItem[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealConstructionItems = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<DealConstructionItem[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
